var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopyIcon2(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 14,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    transform: "translate(0.000162601 -0.00032568)",
    d: "M1.3333334 0C0.59999996 0 0 0.59999996 0 1.3333334L0 10.666667L1.3333334 10.666667L1.3333334 1.3333334L9.333333 1.3333334L9.333333 0L1.3333334 0ZM4 2.6666667C3.2666667 2.6666667 2.6666667 3.2666667 2.6666667 4L2.6666667 13.333333C2.6666667 14.066667 3.2666667 14.666667 4 14.666667L11.333333 14.666667C12.066667 14.666667 12.666667 14.066667 12.666667 13.333333L12.666667 4C12.666667 3.2666667 12.066667 2.6666667 11.333333 2.6666667L4 2.6666667ZM4 13.333333L4 4L11.333333 4L11.333333 13.333333L4 13.333333Z",
    fillRule: "evenodd"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopyIcon2);
export default __webpack_public_path__ + "static/media/CopyIcon2.03b6c5cb36d15cd586245990945f4aa0.svg";
export { ForwardRef as ReactComponent };